type MutableRecord = Record<string, unknown>;

const redactedErrorMessage = "[REDACTED ERROR]";
const redactedErrorStack = "[REDACTED STACK]";
const safeErrorTypePattern =
  /^(?:Error|EvalError|RangeError|ReferenceError|SyntaxError|TypeError|URIError|AggregateError|AbortError|AxiosError|ChunkLoadError|NetworkError|TimeoutError)$/;
const allowedErrorFields = new Set(
  "id message source stack is_crash fingerprint type category handling handling_stack source_type resource".split(
    " ",
  ),
);

function isRecord(value: unknown): value is MutableRecord {
  if (typeof value !== "object" || value === null || Array.isArray(value)) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return prototype === Object.prototype || prototype === null;
}

export function sanitizeRumError(value: unknown, sanitizeUrl: (value: string) => string): boolean {
  if (!isRecord(value) || Object.keys(value).some((key) => !allowedErrorFields.has(key))) {
    return false;
  }
  const error = value;
  if (typeof error.message !== "string") {
    return false;
  }
  if (typeof error.type === "string" && !safeErrorTypePattern.test(error.type)) {
    return false;
  }

  error.message = redactedErrorMessage;
  if (typeof error.stack === "string") {
    error.stack = redactedErrorStack;
  }
  if (typeof error.handling_stack === "string") {
    error.handling_stack = redactedErrorStack;
  }
  if (typeof error.fingerprint === "string") {
    error.fingerprint = redactedErrorMessage;
  }

  if (error.resource !== undefined) {
    if (!isRecord(error.resource)) {
      return false;
    }
    const resource = error.resource;
    if (Object.keys(resource).some((key) => !["method", "status_code", "url"].includes(key))) {
      return false;
    }
    if (typeof resource.url !== "string") {
      return false;
    }
    resource.url = sanitizeUrl(resource.url);
  }

  return true;
}
